// extracted by mini-css-extract-plugin
export default {"contentFrame":"ContentFrame_contentFrame__jo5A9","contentTitle":"ContentFrame_contentTitle__YoZWW","contentText":"ContentFrame_contentText__fN7mw"};